import AuraControlledAutocomplete from 'app/main/apps/common/AuraControlledAutocomplete';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import format from 'date-fns/format';
import { Controller, useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStatuses } from 'app/main/dashboards/main/store/widgetsSlice';
import { getShippingCarriers } from 'app/main/apps/backoffice/store/shipmentOrderSlice';
import { isSupplier, isCustomer, checkNullOrUndefined } from 'app/main/apps/common/AuraFunctions';
import NotificationCard from 'app/main/apps/backoffice/notifications/NotificationCard';
import { Box } from '@mui/material';
import NoItemMessage from 'app/main/apps/common/NoItemMessage';
import AuraAccordion from 'app/main/apps/common/AuraAccordion';
import { SimpleSelectableCardDocumentsViewer } from 'app/main/apps/common/ImageRenderer';
import Attachments from '../../shared/Attachments';

const accordionStyle = {
  root: {
    borderRadius: 2,
    mb: 2,
    boxShadow: "none",
    backgroundColor: "#f1f5f9",
  },
  rootExpanded: {
    backgroundColor: "#fff",
  },
  summary: {
    minHeight: "48px !important",
    padding: "0px 4px",
  },
  summaryContentExpanded: {
    margin: "0",
  },
  title: {
    color: "#4f46e5",
    fontWeight: "700",
    fontSize: "16px",
    textTransform: "uppercase",
  },
  details: {
    backgroundColor: "#fff",
    padding: "0px",
  },
};

function NoteFormContent(props) {
  const { confirmOrder, uiId, orderDialog, title, extraParam } = props;
  const currentUser = useSelector(({ user }) => user);
  const methods = useFormContext();
  const { control, formState, watch } = methods;
  const noteType = watch('note_type')
  const isInternalNotes = watch('isInternalNotes')
  const { errors } = formState;
  const dialogParam = orderDialog?.param;
  const [expandedAccordions, setExpandedAccordions] = useState({
    notesHistory: true,
  });

  const getNoteRows = () => {
    if (isDialogType('approveActions') && orderDialog.stage === 'shipment') {
      return 5;
    }
    return 3
  }

  const getLable = () => {
    if (isDialogType('review_note') && dialogParam?.title !== 'Mark as Completed') {
      return 'Reply back'
    }
    if (['Reject Quote', 'Reject Order', 'Reject Vas Price'].includes(title)) {
      return 'Reject Comments'
    }
    if (['Request Revision for Proof', 'Reject Proof'].includes(title)) {
      return 'Reason'
    }
    if (['Approve Quote', 'Approve Order', 'Approve Vas Price',].includes(title)) {
      return 'Additional Comments'
    }
    if (['Request Quote Revision', 'Request Revision for Drawing', 'Request Revision for Vas price', 'Request Revision for Order'].includes(title)) {
      return 'Revision Comments'
    }
    return 'Notes'
  }

  const showRevisionDocument = () => {
    if (['Request Quote Revision', 'Request Revision for Drawing', 'Request Revision for Vas price', 'Request Revision for Order'].includes(title) || dialogParam.showUploadRevisionDocuments === true) {
      return true
    }
    return false;
  }

  const isDialogType = (name) => {
    return dialogParam && dialogParam.name === name;
  }

  const dispatch = useDispatch()
  const [reason, setReason] = useState([])
  const shippingCarrierNames = useSelector(
    ({ backofficeApp }) => backofficeApp?.shipmentOrder?.shippingCarrierNames
  );

  const selectReasonFor = ['REJECT', 'REJECT_DRAWING', 'REJECT_QUOTE'].includes(uiId)

  useEffect(() => {
    if (selectReasonFor) {
      dispatch(getStatuses('reject_reason'))
      .then((response) => {
        if(!response?.error) {
          setReason(response?.payload?.data || [])
        }
      })
    }
  }, [])

  useEffect(() => {
    // Carrier picker on the dispatch dialog; values come from the `shipping_carrier` category.
    if (extraParam?.isDispatchShiment === true && !shippingCarrierNames?.length) {
      dispatch(getShippingCarriers());
    }
  }, [extraParam?.isDispatchShiment])

  const showOnlyNotes = ['Request Quote Revision', 'Request Revision for Drawing'].includes(title)

  /**
  * Accordion toggle handle
  */
  const handleToggle = (accordionKey) => (event, isExpanded) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [accordionKey]: isExpanded,
    }));
  };

  return (
    <>
      {isDialogType("notesHistory") && (
        <>
        {extraParam.addNote &&
          <Controller
            control={control}
            name={extraParam.noteFieldName}
            render={({ field }) => (
              <TextField
                {...field}
                className="mb-24"
                label={extraParam.noteFieldLabelName}
                id="note"
                variant="outlined"
                fullWidth
                size="small"
                multiline
                rows="3"
                error={!!errors[extraParam.noteFieldName]}
                helperText={errors?.[extraParam.noteFieldName]?.message}
              />
            )}
          />
        }
        {(!extraParam.hideLatestNote && extraParam.notesData.length > 0) &&
        <div className='mb-24 flex flex-row'>
          <Typography className=''>Latest Status: </Typography>
          <Typography className='font-bold text-green ml-12'>{extraParam.notesData[extraParam.notesData.length - 1].comments} </Typography>
        </div>
        }
        {extraParam.showNoteHistory && (
          <div>
            <AuraAccordion
              title={extraParam.noteHistoryTitle  || "History"}
              isExpanded={expandedAccordions.notesHistory}
              onChange={handleToggle("notesHistory")}
              styles={accordionStyle}
            >
              {extraParam.notesData.length > 0 && (
                <div className="my-12"> {
                  extraParam.notesData?.map((item, index) => {
                    return (<>
                      <NotificationCard
                        key={item.id}
                        className="mb-16"
                        item={item}
                        parent="notes"
                      /></>
                    );
                  })}
                </div>
              )}
              {(!extraParam.notesData || extraParam.notesData.length === 0) && !extraParam.hideEmptyHistory && (
                <Box>
                  <NoItemMessage
                    message={`No ${extraParam.noteHistoryTitle  || "History Data"} Found!`}
                    style={{ message: "text-16" }}
                  />
                </Box>
              )}
            </AuraAccordion>
          </div>
          )}
        </>
      )}
      {/* PGSS-5175: read revision_note, not reject_note. This panel is labelled "Revision Note" and is only
          used by the supplier drawing-revision dialog, but it used to read reject_note — which worked only
          because reject_note passed orders.note through unchanged, whatever had written it. reject_note is
          now gated to genuinely rejected orders, and revision_note is the field that actually carries the
          latest revision note here. */}
      {extraParam.showLatestRevisionNote === true &&
        <div className='mb-24 flex flex-row'>
          <Typography className=''>Revision Note: </Typography>
          <Typography className='font-bold text-red ml-12'>{orderDialog?.data?.revision_note}</Typography>
        </div>
      }
      {confirmOrder && (
        <>
          <div className="flex flex-col md:flex-row w-full">
            <div className="flex w-full ">
              <Controller
                control={control}
                name="order_no"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mb-24"
                    label="Order No *"
                    id="order_no"
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={!!errors.order_no}
                    helperText={errors?.order_no?.message}
                  />
                )}
              />
            </div>
          </div>
          {/* <div className="flex flex-col md:flex-row w-full">
            <div className="flex w-full ">
              <Controller
                control={control}
                name="shipping_cost"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mb-24"
                    label="Shipping Cost"
                    id="shipping_cost"
                    type="number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      classes: {
                        input: 'FuseSearch-input py-4 h-20',
                        notchedOutline: 'rounded-8',
                      },
                      readOnly: false,
                    }}
                    error={!!errors.shipping_cost}
                    helperText={errors?.shipping_cost?.message}
                  />
                )}
              />
            </div>
          </div> */}
        </>
      )}
      {extraParam.isDispatchShiment === true && (
        <>
          <div className="flex items-end mb-8 space-x-6">
            <Typography
              className="font-mono text-md tracking-wider"
              color="text.secondary"
            >
              <span className="font-bold">Shipment Type: </span> {orderDialog?.data?.shipment_type || ''}
            </Typography>
          </div>
          <div className="flex items-end mb-8 space-x-6">
            <Typography
              className="font-mono text-md tracking-wider"
              color="text.secondary"
            >
              <span className="font-bold">No of Pallets: </span> {orderDialog?.data?.pallet_count || '-'}
            </Typography>
          </div>
          <div className="flex items-end mb-20 space-x-6">
            <Typography
              className="font-mono text-md tracking-wider"
              color="text.secondary"
            >
              <span className="font-bold">Approval Notes: </span> {orderDialog?.data?.notes || '-'}
            </Typography>
          </div>
          <Controller
            control={control}
            name="schedule"
            render={({ field }) => (
              <TextField
                {...field}
                className="mb-20"
                label="Shipping date *"
                id="schedule"
                type="date"
                variant="outlined"
                fullWidth
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    min: new Date().toISOString().split("T")[0], // Sets the minimum date to today
                  },
                }}
                error={!!errors.schedule}
                helperText={errors?.schedule?.message}
              />
            )}
          />
          {/* Carrier + tracking number are optional here: the PRO number is often only issued when the
              carrier physically picks the freight up. They can be filled in later from Edit Shipment. */}
          <div className="flex flex-col md:flex-row w-full gap-10">
            <div className="flex w-full">
              <AuraControlledAutocomplete
                labelName="Carrier"
                control={control}
                controlName="carrier"
                inputValues={shippingCarrierNames || []}
                defaultValue=""
                className="mt-0 mb-20"
                error={!!errors.carrier}
                helperText={errors?.carrier?.message}
              />
            </div>
            <div className="flex w-full">
              <Controller
                control={control}
                name="tracking_number"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mb-20"
                    label="Tracking / PRO Number"
                    id="tracking_number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={!!errors.tracking_number}
                    helperText={errors?.tracking_number?.message}
                  />
                )}
              />
            </div>
          </div>
        </>
      )}
      {isDialogType('review_note') && orderDialog?.data?.length > 0 && (
        <div className="flex w-full mb-8">
          <div className="flex w-full">
            <div className='mb-10 p-10 overflow-scroll border !border-black w-full' style={{ height: '19rem' }}>
              {
                orderDialog.data.map((note, index) => {
                  return (
                    <div key={`key-${index}`}>
                      <div className='font-semibold'>{note?.added_by}<span className='text-xs text-slate-400 font-light ml-4'>{format(new Date(note.added_on), 'MMM dd, yyyy h:mm a')}</span></div>
                      <div className='font-light mb-10'>{note?.note}</div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col md:flex-row w-full">
        {
          selectReasonFor && !showOnlyNotes && (
            <div className="flex w-full mb-8">
              <div className="flex w-full">
                <AuraControlledAutocomplete
                  labelName={currentUser.role === 'customer' ?  "Reject Reason": 'Notes Type'} 
                  control={control}
                  controlName='note_type'
                  inputValues={reason}
                  error={!!errors.note_type}
                  helperText={errors?.note_type?.message}
                />
              </div>
            </div>
          )
        }
      </div>
      
      {/* Warning Message */}
      {orderDialog?.param?.showCapacityWarning === true && !checkNullOrUndefined(orderDialog?.param?.capacityExceedPercentage) && (
        <p className="text-red-600 text-md font-bold  mb-24">
          Warning: Shipment Capacity exceeded by {orderDialog?.param?.capacityExceedPercentage}% !
        </p>
      )}

      {((noteType?.name === 'Others' || !selectReasonFor || showOnlyNotes) && !isDialogType('notesHistory') && !dialogParam.showAutoNote) && (
        <div className="flex w-full mb-8">
          <div className="flex w-full flex-col">
            {/* Textbox */}
            <Controller
              control={control}
              name="note"
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mb-24"
                  label={getLable()}
                  id="note"
                  variant="outlined"
                  fullWidth
                  size="small"
                  multiline
                  rows={getNoteRows()}
                  error={!!errors.note}
                  helperText={errors?.note?.message}
                  InputProps={{ readOnly: title === 'View Note' }}
                />
              )}
            />
          </div>
        </div>

      )}
      {dialogParam.showAutoNote && 
        <Controller
          control={control}
          name={dialogParam?.noteFieldName || "note"}
          render={({ field }) => (
            <TextField
              {...field}
              className="mb-24"
              label={dialogParam?.noteFieldLabelName || "note"}
              id="note"
              variant="outlined"
              fullWidth
              size="small"
              multiline
              rows="3"
              required={dialogParam?.noteIsRequired ?? true}
              error={!!errors[dialogParam?.noteFieldName || "note"]}
              helperText={errors?.[dialogParam?.noteFieldName || "note"]?.message}
            />
          )}
        />
      }
      {extraParam.showPoReferenceNumberField && (
        <>
          <div className="flex w-full">
            <Controller
              name="customer_po_number"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mt-8 mb-16"
                  id="customer_po_number"
                  label="PO number"
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </div>

          <div className="flex w-full">
            <Controller
              name="product_reference_no"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mt-8 mb-16"
                  id="product_reference_no"
                  label="Product Reference number"
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </div>
        </>
      )}
      {isDialogType('review_note') && !isSupplier(currentUser.role) && !isCustomer(currentUser.role) && dialogParam?.title !== 'Mark as Completed' && (
          <div className="flex w-full w-1/4">
            <div className="flex w-full mb-24 justify-end">
              <Controller
                name="isInternalNotes"
                type="checkbox"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <Checkbox
                    checked={value}
                    className="p-0 pl-10"
                    onChange={(ev) => onChange(ev.target.checked)}
                  />
                )}
              />
              <Typography className="text-14 ">Add Internal Notes</Typography>
            </div>
          </div>
      )}
      {isDialogType('review_note') && dialogParam?.title !== 'Mark as Completed' && isInternalNotes && (
          <div className="flex w-full mb-8">
            <div className="flex w-full">
              <Controller
                control={control}
                name="internalNote"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mb-24"
                    label="Note"
                    id="internalNote"
                    variant="outlined"
                    fullWidth
                    size="small"
                    multiline
                    rows={3}
                  />
                )}
              />
            </div>
          </div>
        )
      }
      {/* Section to check/uncheck revision documents in the "Make it To In-Review", "Request Drawing" popup */}
      {dialogParam.chooseRevisionDocuments === true &&
        <>
          <Typography className="font-semibold pb-12">
            Revision Documents
          </Typography>
          <SimpleSelectableCardDocumentsViewer
            attachments={orderDialog?.data?.revision_documents}
            width="w-[11rem]"
            height="h-[8rem]"
            fontSize="text-12"
            handleSelectionMedia={(media) =>
              extraParam.handleSelectedRevisionImages(media)
            }
            selected={extraParam.selectedRevisionImages}
          />
        </>
      }
      {/* Section to select new revision documents in revision popup */}
      {showRevisionDocument() &&
        <div className="flex flex-col w-full mb-8">
          <div className="">
            <Attachments
              category="document"
              addTo="revision"
              allowAdd
              attachmentKey="revision_documents"
              attachmentsType="revision_documents"
              allowDelete
              width="w-[11rem]"
              height="h-[8rem]"
              fontSize="text-12"
              smallButton
              payload={{ image_customisation_type: "revision" }}
            />
            </div>
        </div>
      }
    </>
  );
}

export default NoteFormContent;
